<template>
  <div>
    <v-toolbar dark color="highlight" flat dense outlined class="sticky">
      <v-toolbar-title>{{$t('attributes')}}</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-menu
        transition="scale-transition"
        origin="right top"
        style="z-index: 10"
        class="white"
        :close-on-content-click="false"
        bottom
        left
      >
        <template v-slot:activator="{ on }">
          <v-badge left color="error" icon="priority_high" overlap>
            <v-btn color="white" icon v-on="on">
              <v-icon>fa-info-circle</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <v-sheet flat width="600px">
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">drag_handle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('info_drag_attribute')}}</v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">fa-asterisk</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('info_star_attribute')}}</v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="red">delete</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('info_delete_attribute')}}</v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon color="secondary">
                <v-icon color="secondary">content_copy</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('info_clone_attribute')}}</v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">refresh</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('info_sync_attribute')}}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
      </v-menu>
      <can I="update" a="settings">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="white"
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              text
              icon
              @click="syncAttributes"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <span>{{$t('info_sync_attribute')}}</span>
        </v-tooltip>

        <addAttribute
          :attributeClasses="attributeClasses"
          v-on:add="addAttribute"
          :index="Math.max.apply(Math, this.attributes.map(function(o) { return o.index; })) + 1"
        />

        <v-btn small depressed color="success" v-if="edit" @click="update">{{$t("save")}}</v-btn>
        <v-btn
          small
          depressed
          class="ml-1"
          :color="edit ? 'disabled': 'primary'"
          @click="edit = !edit"
        >{{edit ? $t("cancel"): $t("edit")}}</v-btn>
      </can>
    </v-toolbar>
    <v-container>
      <v-card>
        <v-data-table
          flat
          show-expand
          :headers="headers"
          :expanded.sync="expanded"
          single-expand
          v-sortable-list
          @sorted="saveOrder"
          :items="attributes"
          item-key="id"
          :footer-props="{
    'items-per-page-options': [-1]
  }"
          :loading="loading"
          :mobile-breakpoint="0"
        >
          <template v-slot:item="props">
            <tr class="sortableRow" :key="props.item.id">
              <td class="px-1" style="width: 0.1%">
                <v-btn
                  :disabled="!edit"
                  color="primary"
                  style="cursor: move"
                  icon
                  class="sortHandle"
                >
                  <v-icon>drag_handle</v-icon>
                </v-btn>
              </td>
              <td>
                <v-text-field
                  dense
                  outlined
                  class="mt-6"
                  :placeholder="props.item.codeFallback"
                  v-if="edit"
                  v-model="props.item.code"
                >
                  <template>{{props.item.code}}</template>
                </v-text-field>
                <template v-else>
                  <template v-if="props.item.code === null">{{props.item.codeFallback}}</template>
                  <template v-else>{{props.item.code}}</template>
                  <template v-if="props.item.isOriginatedByPim">*</template>
                </template>
              </td>
              <td>{{ props.item.qrLogAttributeClass.name }}</td>
              <td>
                <!-- <v-btn v-if="props.item.customerId" icon ripple @click="deleteAttribute(props.item.id)">
              <v-icon>delete</v-icon>
                </v-btn>-->
                <v-switch
                  color="primary"
                  :disabled="!edit"
                  v-model="props.item.visible"
                  @click:append="props.item.visible = !props.item.visible"
                ></v-switch>
              </td>
              <td>
                <v-switch
                  color="primary"
                  :disabled="!edit"
                  v-model="props.item.required"
                  @click:append="props.item.required = !props.item.required"
                ></v-switch>
              </td>

              <td>
                <!-- <v-btn
                  depressed
                  @click="selectedAttribute = props.item; cloneDialog = true"
                >{{$t('clone')}}</v-btn>-->
                <v-btn
                  icon
                  color="secondary"
                  @click="selectedAttribute = props.item; cloneDialog = true"
                >
                  <v-icon>content_copy</v-icon>
                </v-btn>
              </td>
              <td>
                <areyousure
                  :disabled="!edit"
                  v-if="props.item.canDelete && !props.item.IsOriginatedByPim"
                  v-on:deleteAttribute="deleteAttribute"
                  :id="props.item.id"
                  object="attribute"
                ></areyousure>
              </td>
              <!-- <td>
              <areyousure
                v-if="!props.item.isOriginatedByPim"
                v-on:deleteAttribute="deleteAttribute"
                :id="props.item.id"
                :icon="true"
                object="attribute"
              ></areyousure>
              <v-icon>lock</v-icon>
              </td>-->
              <td>
                <v-btn
                  icon
                  v-if="props.item.qrLogAttributeClass.code == 'list'"
                  @click="showValues(props.item, props.item.qrLogAttributeClass.code)"
                >
                  <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <!-- <template v-slot:item.data-table-expand="{expand}">
        <td>testtt</td>
          </template>-->

          <template v-slot:expanded-item="{headers}">
            <td :colspan="headers.length + 1">
              <v-container
                class="active-row active-row-right"
                fluid
                v-if="expanded != null && expanded.length > 0"
              >
                <v-toolbar class="pl-0" dense flat>
                  <v-subheader>{{$t("values")}}</v-subheader>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <!-- <list-transition  :height="90" tag="v-list"> -->
                <div v-for="value in attributeValues" v-bind:key="value.id">
                  <v-list-item>
                    <v-list-item-content>
                      <v-text-field
                        dense
                        outlined
                        class
                        :placeholder="value.descriptionFallback"
                        v-if="edit && value.qrLogAttributeListValueGlobalRefId === null  && value.canDelete"
                        v-model="value.description"
                      >
                        <template>{{value.description}}</template>
                      </v-text-field>
                      <template v-else>
                        <template v-if="value.description == null">{{ value.descriptionFallback }}</template>
                        <template v-else>{{ value.description }}</template>
                      </template>
                      <template v-if="value.qrLogAttributeListValueGlobalRefId !== null">*</template>
                    </v-list-item-content>
                    <v-list-item-action class="align-end">
                      <!-- <v-btn icon ripple @click="removeValue(value.id)">
                      <v-icon>delete</v-icon>
                      </v-btn>-->

                      <areyousure
                        :disabled="!edit"
                        v-if="value.qrLogAttributeListValueGlobalRefId === null && value.canDelete"
                        v-on:deleteValue="deleteValue"
                        :id="value.id"
                        :icon="true"
                        object="attributeValue"
                      ></areyousure>
                      <v-checkbox
                        :label="$t('active')"
                        v-model="value.isActive"
                        :disabled="!edit"
                        @change="putQrlogAttributeListValue(value)"
                        class="mr-5"
                      ></v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                </div>
                <!-- </list-transition> -->
                <v-list-item>
                  <v-text-field
                    dense
                    outlined
                    class="mt-6"
                    v-model="newAttributeValue"
                    v-bind:label="$t('value')"
                  ></v-text-field>
                  <can I="create" a="settings">
                    <v-btn
                      class="ml-1"
                      small
                      depressed
                      :disabled="!newAttributeValue && newAttributeValue === ''"
                      @click="saveValue(attributeId)"
                      color="primary"
                    >{{$t('add')}}</v-btn>
                  </can>
                </v-list-item>
              </v-container>
            </td>
          </template>
        </v-data-table>
        <v-dialog v-if="selectedAttribute" v-model="cloneDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">{{selectedAttribute.code}}</v-card-title>
            <v-card-text>
              <p>{{$t('cloneAttributeWithValues')}}</p>
              <v-form ref="cloneForm">
                <v-text-field
                  filled
                  dense
                  :rules="[v=>!!v,v => v.trim() != selectedAttribute.code.trim()]"
                  v-model="clonedAttributeName"
                  :label="$t('giveADifferentName')"
                ></v-text-field>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="grey darken-1" text @click="cloneDialog = false">{{$t('cancel')}}</v-btn>

              <v-btn color="secondary" depressed @click="clone">{{$t('clone')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-container>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/velocity/1.2.3/velocity.min.js"></script>

<script>
import uuid from "uuid";
import draggable from "vuedraggable";
import Sortable from "sortablejs";
import addAttribute from "@/components/pages/Settings/AddAttribute";

export default {
  name: "Settings",
  components: { addAttribute },
  directives: {
    sortableList: {
      bind(el, binding, vnode) {
        let sortableElement = el.getElementsByTagName("tbody")[0];
        const options = {
          handle: ".sortHandle",
          animation: 150,
          onUpdate: function(event) {
            vnode.child.$emit("sorted", event);
          }
        };
        Sortable.create(sortableElement, options);
      }
    }
  },
  data() {
    return {
      loading: false,
      selectedAttribute: null,
      cloneDialog: false,
      clonedAttributeName: null,
      active: null,
      expanded: [],
      showValueList: false,
      edit: false,
      attributeId: "",
      attributes: [],
      attributeClasses: [],
      attributeValues: [],
      newAttributeCode: "",
      newAttributeClass: "",
      newAttributeValue: "",
      headers: [
        {
          text: this.$t("name"),
          data: "code",
          sortable: false
        },
        {
          text: this.$t("class"),
          data: "class",
          sortable: false
        },
        { text: this.$t("active"), sortable: false },
        { text: this.$t("required"), sortable: false },
        { text: this.$t("clone"), sortable: false },
        { text: this.$t("delete"), sortable: false },
        // { text: this.$t("actions"), sortable: false },

        { text: "", sortable: false }
      ]
    };
  },
  methods: {
    clone() {
      if (this.$refs.cloneForm.validate()) {
        let a = JSON.parse(JSON.stringify(this.selectedAttribute));
        a.code = this.clonedAttributeName;
        this.$http
          .cloneQRLogAttribute(a)
          .then(res => {
            this.cloneDialog = false;
            this.$router.go();
          })
          .catch(err => {
            console.log(err);
            this.cloneDialog = false;
            this.$noty.error(err);
          });
      }
    },
    putQrlogAttributeListValue(value) {
      this.loading = true;
      this.$http
        .updateAttributeValue(value)
        .then(res => {
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    saveOrder({ oldIndex, newIndex }) {
      this.loading = true;
      const movedItem = this.attributes.splice(oldIndex, 1)[0];
      this.attributes.splice(newIndex, 0, movedItem);
      for (let i = 0; i < this.attributes.length; i++) {
        this.attributes[i].index = i;
      }
      this.$http
        .updateAttributesPosition(
          this.attributes.map(x => ({ id: x.id, index: x.index }))
        )
        .then(res => {
          this.$noty.success('<i class="fas fa-check"></i>');
          this.$store.state.allAttributes = null;
          this.loading = false;
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
          this.loading = false;
        });
    },
    saveValue(attributeId) {
      if (this.newAttributeValue && this.newAttributeValue !== "") {
        this.loading = true;
        const attributeValue = {
          id: uuid.v4(),
          description: this.newAttributeValue,
          qrLogAttributeId: attributeId,
          isActive: true,
          qrLogAttributeListValueGlobalRefId: null
        };
        this.$http
          .saveAttributeValue(attributeValue)
          .then(res => {
            res.data.qrLogAttributeListValueGlobalRefId = null
            res.data.canDelete = true
            this.attributeValues.push(res.data);
            this.newAttributeValue = "";
            this.$noty.success('<i class="fas fa-check"></i>');
            this.$store.state.allAttributes = null;
            this.loading = false;
            // this.expanded.pop();
            // this.attributeId = null;
          })
          .catch(err => {
            this.$noty.error(this.$t("error"));
            console.log(err);
            this.loading = false;
          });
      }
    },
    addAttribute(attribute) {
      this.attributes.push(attribute);
      this.$store.state.allAttributes = null;
    },
    showValues(attribute, attributeClass) {
      this.loading = true;
      if (this.attributeId == attribute.id && this.expanded.length > 0) {
        this.expanded.pop();
        this.loading = false;
      } else {
        this.expanded.pop();
        this.expanded.push(attribute);
        if (this.attributeValues.length > 0) {
          if (this.attributeValues[0].qrLogAttributeId != attribute.id) {
            this.attributeId = attribute.id;
            this.$http
              .showValues(attribute.id)
              .then(res => {
                this.attributeValues = res.data;
                this.$forceUpdate();
                this.loading = false;
              })
              .catch(err => {
                console.log(err);
                this.loading = false;
              });
          } else {
            this.loading = false;
          }
        } else {
          this.attributeId = attribute.id;
          this.$http
            .showValues(attribute.id)
            .then(res => {
              this.attributeValues = res.data;
              this.$forceUpdate();
              this.loading = false;
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
            });
        }
      }
    },
    deleteValue(valueId) {
      this.attributeValues = this.attributeValues.filter(p => p.id != valueId);
      this.$store.state.allAttributes = null;
    },
    update() {
      this.loading = true;
      this.$http
        .updateAttribute(this.attributes)
        .then(res => {
          this.$noty.success('<i class="fas fa-check"></i>');
          this.$store.state.allAttributes = null;
          this.loading = false;
        })
        .catch(err => {
          this.$noty.error(err);
          console.log(err);
          this.loading = false;
        });

      this.$http
        .updateAttributeValues(this.attributeValues)
        .then(res => {
          // this.$noty.success('<i class="fas fa-check"></i>');
          this.$store.state.allAttributes = null;
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    deleteAttribute(id) {
      this.attributes = this.attributes.filter(p => p.id != id);
      this.$store.state.allAttributes = null;
    },
    changeVisibility(attribute) {
      this.$http
        .changeVisibility(attribute)
        .then(res => {
          this.$noty.success('<i class="fas fa-check"></i>');
          this.$store.state.allAttributes = null;
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    changeRequired(attribute) {
      this.$http
        .changeVisibility(attribute)
        .then(res => {
          this.$noty.success('<i class="fas fa-check"></i>');
          this.$store.state.allAttributes = null;
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    syncAttributes() {
      this.loading = true;
      this.$http
        .syncAttributes()
        .then(res => {
          this.$noty.success('<i class="fas fa-check"></i>');
          this.$store.state.allAttributes = null;
          this.loading = false;
          this.$router.go();
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    }
  },
  created() {
    this.loading = true;
    this.$http
      .getAttributes()
      .then(res => {
        this.attributes = res.data;
        this.loading = false;
      })
      .catch(err => {
        console.log(err);
        this.loading = false;
      });

    this.$http
      .getAttributeClasses()
      .then(res => {
        this.attributeClasses = res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/views/settings/Index.vue